"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomizeAgentScreen = CustomizeAgentScreen;
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _field = require("@design/ui/field");
var _input = require("@design/ui/input");
var _kbd = require("@design/ui/kbd");
var _label = require("@design/ui/label");
var _customizeAgent = require("./customize-agent.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function CustomizeAgentScreen() {
  var _w$customizeAgentSlot, _w$fieldShowLabel, _w$fieldShowDescripti, _w$fieldDescription, _w$fieldSlot, _w$fieldShowLabel2, _w$fieldShowDescripti2, _w$fieldDescription2, _w$fieldSlot2, _w$fieldShowLabel3, _w$fieldShowDescripti3, _w$fieldDescription3, _w$fieldSlot3, _w$selectShowIcon, _w$selectPlaceholder, _w$customizeAgentShow, _w$buttonShowIconStar, _w$buttonLabel, _w$buttonShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon, _w$buttonShowIconEnd, _w$buttonShowIconStar2, _w$buttonLabel2, _w$buttonShowKbd2, _w$kbdShowLeftIcon2, _w$kbdLabel2, _w$kbdShowRightIcon2, _w$buttonShowIconEnd2, _w$customizeAgentShow2;
  var w = (0, _customizeAgent.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "center",
      alignSelf: "stretch"
    },
    "data-sentry-component": "CustomizeAgentScreen",
    "data-sentry-source-file": "customize-agent.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "4px 4px 4px 4px",
        alignSelf: "stretch",
        maxHeight: "800px",
        backgroundColor: "rgba(255, 255, 255, 1)",
        border: "1px solid rgba(234, 231, 220, 1)",
        borderRadius: "8px 8px 0px 0px",
        boxShadow: "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1)"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          padding: "4px 4px 4px 4px",
          alignSelf: "stretch"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            alignItems: "flex-start",
            padding: "4px 4px 4px 4px",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              flexGrow: "1",
              flexBasis: "0",
              minWidth: "0",
              color: "rgba(28, 25, 23, 1)",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "24px"
            },
            children: "Customize Agent"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-start"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                width: "16px",
                maxWidth: "100%",
                height: "16px",
                borderRadius: "8px",
                opacity: "0.699999988079071"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, _objectSpread(_objectSpread({}, w.close), {}, {
                "data-sentry-element": "CloseIcon",
                "data-sentry-source-file": "customize-agent.tsx"
              }))
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "flex-start",
            padding: "4px 4px 4px 4px",
            alignSelf: "stretch"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              alignSelf: "stretch",
              color: "rgba(100, 97, 92, 1)",
              fontFamily: "Inter",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px"
            },
            children: "Set up how the agent works for you"
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          gap: "4px",
          justifyContent: "center",
          alignItems: "safe center",
          padding: "4px 4px 4px 4px",
          alignSelf: "stretch",
          overflowY: "auto"
        },
        children: (_w$customizeAgentSlot = w.customizeAgentSlot) !== null && _w$customizeAgentSlot !== void 0 ? _w$customizeAgentSlot : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              alignItems: "flex-start",
              padding: "12px 12px 12px 12px",
              flexGrow: "1",
              flexBasis: "0",
              minWidth: "0"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, _objectSpread(_objectSpread({}, w.field), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: [((_w$fieldShowLabel = w.fieldShowLabel) !== null && _w$fieldShowLabel !== void 0 ? _w$fieldShowLabel : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, _objectSpread(_objectSpread({}, w.label), {}, {
                  children: "Agent Name"
                })) : null, ((_w$fieldShowDescripti = w.fieldShowDescription) !== null && _w$fieldShowDescripti !== void 0 ? _w$fieldShowDescripti : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  style: {
                    alignSelf: "stretch",
                    color: "rgba(142, 138, 131, 1)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px"
                  },
                  children: (_w$fieldDescription = w.fieldDescription) !== null && _w$fieldDescription !== void 0 ? _w$fieldDescription : "This will be the author for redlines and comments in Word"
                }) : null]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: (_w$fieldSlot = w.fieldSlot) !== null && _w$fieldSlot !== void 0 ? _w$fieldSlot : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, _objectSpread(_objectSpread({}, w.input), {}, {
                    type: "text",
                    placeholder: "Vera Engage"
                  }))
                })
              })]
            })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, _objectSpread(_objectSpread({}, w.field2), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: [((_w$fieldShowLabel2 = w.fieldShowLabel2) !== null && _w$fieldShowLabel2 !== void 0 ? _w$fieldShowLabel2 : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, _objectSpread(_objectSpread({}, w.label2), {}, {
                  children: "Agent Instructions"
                })) : null, ((_w$fieldShowDescripti2 = w.fieldShowDescription2) !== null && _w$fieldShowDescripti2 !== void 0 ? _w$fieldShowDescripti2 : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  style: {
                    alignSelf: "stretch",
                    color: "rgba(142, 138, 131, 1)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px"
                  },
                  children: (_w$fieldDescription2 = w.fieldDescription2) !== null && _w$fieldDescription2 !== void 0 ? _w$fieldDescription2 : "Tell the agent who it is and how to behave"
                }) : null]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: (_w$fieldSlot2 = w.fieldSlot2) !== null && _w$fieldSlot2 !== void 0 ? _w$fieldSlot2 : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_input.Input, _objectSpread(_objectSpread({}, w.input2), {}, {
                    type: "text",
                    placeholder: "e.g. always respond to me in French"
                  }))
                })
              })]
            })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, _objectSpread(_objectSpread({}, w.field3), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: [((_w$fieldShowLabel3 = w.fieldShowLabel3) !== null && _w$fieldShowLabel3 !== void 0 ? _w$fieldShowLabel3 : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, _objectSpread(_objectSpread({}, w.label3), {}, {
                  children: "Model"
                })) : null, ((_w$fieldShowDescripti3 = w.fieldShowDescription3) !== null && _w$fieldShowDescripti3 !== void 0 ? _w$fieldShowDescripti3 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  style: {
                    width: "328px",
                    maxWidth: "100%",
                    height: "40px",
                    color: "rgba(142, 138, 131, 1)",
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px"
                  },
                  children: (_w$fieldDescription3 = w.fieldDescription3) !== null && _w$fieldDescription3 !== void 0 ? _w$fieldDescription3 : "This will be the author for redlines and comments in Word"
                }) : null]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  alignItems: "flex-start",
                  alignSelf: "stretch"
                },
                children: (_w$fieldSlot3 = w.fieldSlot3) !== null && _w$fieldSlot3 !== void 0 ? _w$fieldSlot3 : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    style: {
                      display: "flex",
                      flexDirection: "row",
                      gap: "8px",
                      alignItems: "center",
                      padding: "8px 12px 8px 12px",
                      alignSelf: "stretch",
                      height: "40px",
                      backgroundColor: "rgba(253, 253, 252, 1)",
                      border: "1px solid rgba(234, 231, 220, 1)",
                      borderRadius: "8px"
                    },
                    children: [((_w$selectShowIcon = w.selectShowIcon) !== null && _w$selectShowIcon !== void 0 ? _w$selectShowIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      },
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        style: {
                          alignSelf: "stretch",
                          flexGrow: "1",
                          flexBasis: "0",
                          minHeight: "0"
                        },
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                          style: {
                            backgroundColor: "rgba(142, 138, 131, 1)"
                          }
                        })
                      })
                    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        flexGrow: "1",
                        flexBasis: "0",
                        minWidth: "0",
                        height: "20px",
                        color: "rgba(28, 25, 23, 1)",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontWeight: "400",
                        lineHeight: "20px"
                      },
                      children: (_w$selectPlaceholder = w.selectPlaceholder) !== null && _w$selectPlaceholder !== void 0 ? _w$selectPlaceholder : "Claude Sonnet 5"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                      src: "data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20clip-path%3D%22url(%23clip0_0_196)%22%3E%0A%3Cpath%20d%3D%22M11.5127%208.56071H3.21377C3.05852%208.56071%202.92856%208.50744%202.82388%208.4009C2.71909%208.29448%202.66669%208.16236%202.66669%208.00453C2.66669%207.8467%202.71909%207.71457%202.82388%207.60816C2.92856%207.50162%203.05852%207.44835%203.21377%207.44835H11.5127L7.74198%203.61497C7.63354%203.50473%207.57998%203.37569%207.58132%203.22787C7.58278%203.08005%207.64004%202.94861%207.7531%202.83354C7.86629%202.72614%207.99443%202.67052%208.13752%202.66669C8.28061%202.66286%208.40875%202.71848%208.52194%202.83354L13.1468%207.5353C13.2151%207.60476%2013.2633%207.67799%2013.2912%207.75499C13.3193%207.83199%2013.3334%207.91517%2013.3334%208.00453C13.3334%208.09389%2013.3193%208.17707%2013.2912%208.25407C13.2633%208.33107%2013.2151%208.4043%2013.1468%208.47376L8.52194%2013.1755C8.42091%2013.2782%208.29581%2013.3307%208.14664%2013.3331C7.99747%2013.3354%207.86629%2013.2829%207.7531%2013.1755C7.64004%2013.0604%207.58351%2012.9283%207.58351%2012.7791C7.58351%2012.6298%207.64004%2012.4977%207.7531%2012.3826L11.5127%208.56071Z%22%20fill%3D%22%238E8A83%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3CclipPath%20id%3D%22clip0_0_196%22%3E%0A%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%2F%3E%0A%3C%2FclipPath%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E",
                      alt: "Icon Placeholder",
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "16px",
                        maxWidth: "100%",
                        height: "16px"
                      }
                    })]
                  })
                })
              })]
            }))]
          })
        })
      }), ((_w$customizeAgentShow = w.customizeAgentShowFooter) !== null && _w$customizeAgentShow !== void 0 ? _w$customizeAgentShow : true) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          alignItems: "center",
          padding: "16px 16px 16px 16px",
          alignSelf: "stretch"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            justifyContent: "flex-end",
            alignItems: "flex-start",
            alignSelf: "stretch"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button), {}, {
            variant: "outline",
            size: "sm",
            children: [((_w$buttonShowIconStar = w.buttonShowIconStart) !== null && _w$buttonShowIconStar !== void 0 ? _w$buttonShowIconStar : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(28, 25, 23, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel = w.buttonLabel) !== null && _w$buttonLabel !== void 0 ? _w$buttonLabel : "Cancel"
            }), ((_w$buttonShowKbd = w.buttonShowKbd) !== null && _w$buttonShowKbd !== void 0 ? _w$buttonShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
              children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(100, 97, 92, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "⌘"
              }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd = w.buttonShowIconEnd) !== null && _w$buttonShowIconEnd !== void 0 ? _w$buttonShowIconEnd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null]
          })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button2), {}, {
            variant: "default",
            size: "sm",
            children: [((_w$buttonShowIconStar2 = w.buttonShowIconStart2) !== null && _w$buttonShowIconStar2 !== void 0 ? _w$buttonShowIconStar2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                color: "rgba(255, 255, 255, 1)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px"
              },
              children: (_w$buttonLabel2 = w.buttonLabel2) !== null && _w$buttonLabel2 !== void 0 ? _w$buttonLabel2 : "Save"
            }), ((_w$buttonShowKbd2 = w.buttonShowKbd2) !== null && _w$buttonShowKbd2 !== void 0 ? _w$buttonShowKbd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd2), {}, {
              children: [((_w$kbdShowLeftIcon2 = w.kbdShowLeftIcon2) !== null && _w$kbdShowLeftIcon2 !== void 0 ? _w$kbdShowLeftIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: "rgba(100, 97, 92, 1)",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: "400",
                  lineHeight: "16px",
                  letterSpacing: "0.12px",
                  textAlign: "center"
                },
                children: (_w$kbdLabel2 = w.kbdLabel2) !== null && _w$kbdLabel2 !== void 0 ? _w$kbdLabel2 : "⌘"
              }), ((_w$kbdShowRightIcon2 = w.kbdShowRightIcon2) !== null && _w$kbdShowRightIcon2 !== void 0 ? _w$kbdShowRightIcon2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "16px",
                  maxWidth: "100%",
                  height: "12px"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    alignSelf: "stretch",
                    flexGrow: "1",
                    flexBasis: "0",
                    minHeight: "0"
                  },
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    style: {
                      backgroundColor: "rgba(142, 138, 131, 1)"
                    }
                  })
                })
              }) : null]
            })) : null, ((_w$buttonShowIconEnd2 = w.buttonShowIconEnd2) !== null && _w$buttonShowIconEnd2 !== void 0 ? _w$buttonShowIconEnd2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "16px",
                maxWidth: "100%",
                height: "16px"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  alignSelf: "stretch",
                  flexGrow: "1",
                  flexBasis: "0",
                  minHeight: "0"
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    backgroundColor: "rgba(142, 138, 131, 1)"
                  }
                })
              })
            }) : null]
          }))]
        })
      }) : null, ((_w$customizeAgentShow2 = w.customizeAgentShowScroller) !== null && _w$customizeAgentShow2 !== void 0 ? _w$customizeAgentShow2 : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          alignSelf: "stretch",
          height: "40px",
          position: "absolute",
          left: "4px",
          right: "4px",
          width: "auto",
          bottom: "68px",
          backgroundImage: "linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 0px 16px 0px",
            borderRadius: "9999px"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({}, w.button3), {}, {
            variant: "outline",
            size: "icon-xs",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, _objectSpread({}, w.iconCaretDown))
          }))
        })
      }) : null]
    })
  });
}